<template>
  <span 
    class="badge border-none rounded-md text-xxs font-normal uppercase font-semibold"
    :class="[
      getStatusButtonClasses(status),
      sizeClasses,
      fullWidth ? 'w-full' : ''
    ]"
  >
    {{ status }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value)
  },
  fullWidth: {
    type: Boolean,
    default: false
  }
})

const getStatusButtonClasses = value => {
  switch (value) {
    case "pending approval":
      return "bg-base-content/5 text-primary"

    case "declined":
      return "bg-base-content/5 text-primary"
    case "subscribed":
      return "bg-base-content/5 text-primary"
    case "unsubscribed":
      return "bg-base-content/5 text-primary"
    case "apply to run":
    case "available":
      return "bg-base-content/5 text-primary"
    default:
      return "bg-base-content/5 text-primary"
  }
}

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'p-1 text-xs'
    case 'lg':
      return 'p-3 text-sm'
    case 'md':
    default:
      return 'p-2'
  }
})
</script>